import { render, staticRenderFns } from "./Learn-detail.vue?vue&type=template&id=6549cd74&"
import script from "./Learn-detail.vue?vue&type=script&lang=js&"
export * from "./Learn-detail.vue?vue&type=script&lang=js&"
import style0 from "./Learn-detail.vue?vue&type=style&index=0&id=6549cd74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports